<ng-container *transloco="let t">
  @if (
    {
      activeLang: activeLang$ | async,
      readOnly: readOnly$ | async,
      errorMessage: errorMessage$ | async,
    };
    as data
  ) {
    <div class="form-group question-container-inner" [formGroup]="questionForm">
      <lib-input-container
        [headLine]="
          question.translations?.list['headLine']
            | translate: data.activeLang : question.structure.headLine
        "
        [description]="
          question.translations?.list['description']
            | translate: data.activeLang : question.structure.description
        "
        [labelPrefix]="questionNumber$ | async"
        [label]="
          question.translations?.list['title']
            | translate: data.activeLang : question.title
        "
        [questionMarkText]="
          question.translations?.list['questionMarkText']
            | translate: data.activeLang : question.structure.questionMarkText
        "
        [helpText]="!data.readOnly ? (helpText$ | async) : ''"
        [required]="minNumberOfCheckedOptions > 0"
        [errorText]="data.errorMessage"
        [for]="labelPrefix + question.id"
        [width]="'full'"
        [requiredTextEnd]="false"
        [id]="labelPrefix + question.id"
        [questionType]="question.type"
      >
        @if (!data.readOnly) {
          <lib-vinnova-checkboxes
            [labelPrefix]="labelPrefixForCheckbox()"
            [required]="minNumberOfCheckedOptions > 0"
            [checkboxObjects]="checkboxObjects()"
            formControlName="value"
            [horizontal]="structure.horizontalOptions"
            [error]="!!data.errorMessage"
            [labelledBy]="labelPrefix + question.id"
            [showChangeIndicatorForIds]="
              showChanges()
                ? previousAnswersService.getChangedCheckboxIds(
                    question.id,
                    repeaterGroupId,
                    value.value
                  )
                : []
            "
          >
          </lib-vinnova-checkboxes>
        }
        @if (data.readOnly) {
          @for (checkbox of readonlyItems(); track $index) {
            <div class="readonly d-flex align-items-center">
              {{ checkbox }}
            </div>
          }
          @if (!readonlyItems() || readonlyItems()?.length === 0) {
            <div
              class="readonly"
              [ngClass]="(errorMessage$ | async) ? 'invalid' : ''"
            ></div>
          }
        }
      </lib-input-container>
    </div>
  }
</ng-container>
